export default "/_next/static/images/nicholas-yu-10204f01419e5c93672324386fcf1acc.png";